import { useState } from "react";
import { Share2, Download, MessageCircle, Instagram, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { makeStoryCard } from "@/lib/storyCard";
import { inr } from "@/lib/api";

export const ShareTryOn = ({ r, p }) => {
  const [busy, setBusy] = useState("");
  const url = `${window.location.origin}/product/${p.slug}`;
  const text = `Look at me in the ${p.name}${r.name ? ` (${r.name} look)` : ""} from REVASTRA ✨ ${url}`;
  const card = async () => new File([await makeStoryCard({ image: r.image, name: p.name, look: r.name, price: inr(p.price) })], "revastra-look.jpg", { type: "image/jpeg" });
  const save = (f) => { const a = document.createElement("a"); a.href = URL.createObjectURL(f); a.download = f.name; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 4000); };
  const run = (kind) => async () => {
    setBusy(kind);
    try {
      const f = await card();
      const canFiles = navigator.canShare?.({ files: [f] });
      if (kind === "whatsapp") {
        if (canFiles) await navigator.share({ files: [f], text });
        else { save(f); window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank"); toast.success("Story card saved. Attach it in WhatsApp."); }
      } else if (kind === "instagram") {
        if (canFiles) await navigator.share({ files: [f] });
        else { save(f); toast.success("Story card saved. Open Instagram → Your story → pick this image."); }
      } else save(f);
    } catch (e) { if (e?.name !== "AbortError") toast.error("Could not create the share image"); }
    finally { setBusy(""); }
  };
  const B = ({ kind, icon: I, label }) => <button onClick={run(kind)} disabled={!!busy} className="flex-1 h-9 rounded-full border border-[var(--rose-soft)] hover:border-[var(--ink)] text-[11px] flex items-center justify-center gap-1.5 disabled:opacity-50" data-testid={`share-${kind}-${r.number}`}>{busy === kind ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <I className="w-3.5 h-3.5" />}{label}</button>;
  return (
    <div className="mt-2 space-y-1.5" data-testid={`share-${r.number}`}>
      <p className="text-[10px] eyebrow text-[var(--taupe)] flex items-center gap-1"><Share2 className="w-3 h-3" /> Share your look</p>
      <div className="flex gap-1.5"><B kind="instagram" icon={Instagram} label="Story" /><B kind="whatsapp" icon={MessageCircle} label="WhatsApp" /><B kind="save" icon={Download} label="Save" /></div>
    </div>
  );
};
